<style lang="stylus" scoped>
    .pcstyleModal-mask
        modal-mask()
        z-index 1001

        .pcstyleModal-box
            position absolute
            width 530px
            position fixed
            top 50%
            left 50%
            transform translate(-50%, -50%)
            background-color #fff
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1), 0px 8px 16px rgba(0, 0, 0, 0.0982299)
            border-radius 8px

            .pcstyleModal-header
                height 40px
                padding 0 8px 0 12px
                display flex
                align-items center
                user-select none

                &.pcstyleModal-online-header
                    padding 0 8px 0 24px

                    .pcstyleModal-header-text
                        font-weight 700


                .pcstyleModal-header-icon
                    width 16px
                    height 16px
                    margin-right 4px

                .pcstyleModal-header-text
                    font-size 12px
                    color #000

                .pcstyleModal-header-close
                    display flex
                    align-items center
                    justify-content center
                    width 24px
                    height 24px
                    margin-left auto
                    cursor pointer
                    border-radius 6px

                    &:hover
                        background rgba(0,0,0,0.06)

                    svg
                        width 16px
                        height 16px
                        stroke #424242
            .pcstyleModal-mac-header
                display flex
                justify-content space-between
                align-items center
                height 28px
                .pcstyleModal-mac-header-btn
                    display flex
                    margin-left 8px
                    &:hover
                        svg
                            display block
                    >div
                        position relative
                        width 12px
                        height 12px
                        border-radius 100px
                        background #DDDDDD
                        box-shadow 0px 0px 0px 0.5px #00000033
                        margin-left 8px
                        &:first-child
                            margin-left 0
                        svg
                            display none
                            position absolute
                            left 0
                            top 0
                            width 12px
                            height 12px
                    .pcstyleModal-mac-red
                        background #FF5F57
                        svg
                            color #671109
                        &:active
                            background #B15048
                            svg
                                color #2e0402
                .pcstyleModal-mac-header-text
                    font-size 12px
                    color #000000D9
                    font-weight 400
                    max-width 60%
                    text-overflow ellipsis
                    white-space nowrap
                    overflow hidden
                    user-select none
            .pcstyleModal-content
                display flex
                padding 24px 22px
                img
                    display block
                    width 24px
                    height 24px
                    margin-right 8px
                p
                    display flex
                    align-items center
                    color #222
                    font-size 12px
            .pcstyleModal-footer
                display flex
                justify-content flex-end
                position relative
                width 100%
                height 28px
                bottom 0
                padding-right 24px
                margin-bottom 24px
                .dialog-btn-ok
                    display flex
                    justify-content center
                    align-items center
                    right 110px
                    padding 0 20px
                    min-width 72px
                    margin-left: 16px;
                    border-radius 6px
                    font-size 12px
                    user-select none
                    cursor pointer
                    background-color #017fff
                    color #fff
                    transition all $box-transition-time;
                    &:hover
                        background-color #006adf

                .dialog-btn-cancel
                    display flex
                    justify-content center
                    align-items center
                    right 110px
                    padding 0 20px
                    min-width 72px
                    margin-left: 16px;
                    border-radius 6px
                    font-size 12px
                    user-select none
                    cursor pointer
                    background-color #EBEDF1
                    color #222
                    transition all $box-transition-time;
                    &:hover
                        background-color #e1e1e1
                &.pcstyleModal-mac-footer
                    flex-direction row-reverse
                    justify-content flex-start

        &.dark-theme__pcstyleModal
            .pcstyleModal-box
                background #3F3F41

                .pcstyleModal-header-text
                    color #fff

                .pcstyleModal-header-close
                    svg
                        stroke #DADADF

                .pcstyleModal-content
                    p
                        color #fff
                .pcstyleModal-footer
                    .dialog-btn-cancel
                        background-color #626365
                        color #fff
                        &:hover
                            background-color #4d4e50

                .gray-btn
                    background #626365 !important
                    p
                        color #fff !important
</style>
<template>
    <div class="pcstyleModal-mask" :class="{ 'dark-theme__pcstyleModal': useDark == 2, noMask: noMask }">
        <div class="pcstyleModal-box" :style="{ width: `${width}px` }">
            <template v-if="isMac">
                <div class="pcstyleModal-mac-header">
                    <div class="pcstyleModal-mac-header-btn">
                        <div class="pcstyleModal-mac-red" @click="close()">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M3.98477 8.93442C3.73092 9.18826 3.31937 9.18826 3.06553 8.93442C2.81169 8.68058 2.81169 8.26903 3.06553 8.01518L5.08082 5.99989L3.06545 3.98452C2.81161 3.73068 2.81161 3.31912 3.06545 3.06528C3.3193 2.81144 3.73085 2.81144 3.98469 3.06528L6.00006 5.08065L8.01527 3.06544C8.26911 2.8116 8.68067 2.8116 8.93451 3.06544C9.18835 3.31928 9.18835 3.73084 8.93451 3.98468L6.9193 5.99989L8.93444 8.01503C9.18828 8.26887 9.18828 8.68043 8.93444 8.93427C8.6806 9.18811 8.26904 9.18811 8.0152 8.93427L6.00006 6.91913L3.98477 8.93442Z"
                                    fill="currentColor"
                                />
                            </svg>
                        </div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="pcstyleModal-mac-header-text" :title="title">{{ title }}</div>
                    <div style="width: 60px"></div>
                </div>
            </template>
            <template v-else>
                <div class="pcstyleModal-header" :class="{ 'pcstyleModal-online-header': !isPC }">
                    <div class="pcstyleModal-header-icon" v-if="isPC">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_11412_26856)">
                                <rect width="16" height="16" fill="url(#paint0_linear_11412_26856)" />
                                <path
                                    d="M7.99999 8.8125H4.75C4.30127 8.8125 3.9375 8.44873 3.9375 8C3.9375 7.55127 4.30127 7.1875 4.75 7.1875H7.99999C8.44872 7.1875 8.81249 7.55127 8.81249 8C8.81249 8.44873 8.44872 8.8125 7.99999 8.8125Z"
                                    fill="white"
                                    fill-opacity="0.6"
                                />
                                <path
                                    d="M7.99999 4.75H4.75C4.30127 4.75 3.9375 4.38623 3.9375 3.9375C3.9375 3.48877 4.30127 3.125 4.75 3.125H7.99999C10.6924 3.125 12.875 5.30761 12.875 7.99999C12.875 10.6924 10.6924 12.875 7.99999 12.875H4.75C4.30127 12.875 3.9375 12.5112 3.9375 12.0625C3.9375 11.6137 4.30127 11.25 4.75 11.25H7.99999C9.79491 11.25 11.25 9.79491 11.25 7.99999C11.25 6.20507 9.79491 4.75 7.99999 4.75Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <linearGradient
                                    id="paint0_linear_11412_26856"
                                    x1="16.7272"
                                    y1="18.6666"
                                    x2="1.16582"
                                    y2="-3.96816"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#0066FF" />
                                    <stop offset="1" stop-color="#66CCFF" />
                                </linearGradient>
                                <clipPath id="clip0_11412_26856">
                                    <rect width="16" height="16" rx="3.65049" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    <span class="pcstyleModal-header-text">{{ title }}</span>
                    <div class="pcstyleModal-header-close" @click="close()">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 3L13 13" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3 13L13 3" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>
            </template>
            <div class="pcstyleModal-content">
                <slot>
                    <img v-if="useIcon" src="./warning.svg" alt="" />
                    <p>{{ content }}</p>
                </slot>
            </div>
            <div class="pcstyleModal-footer" v-if="confirmText || cancelText" :class="{ 'pcstyleModal-mac-footer': isMac }">
                <div class="dialog-btn-ok" v-if="confirmText" @click="confirm()">{{ confirmText }}</div>
                <div class="dialog-btn-cancel" v-if="cancelText" @click="cancel()">{{ cancelText }}</div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { isMac } from "@/public/utils/customVue";

    @Component
    export default class edmodal extends Vue {
        useAsPlugin = false;
        width = 400;

        title = "";
        content = "";
        useDark = 0;
        useIcon = false;
        isPC = false;
        confirmText = "";
        cancelText = "";
        eventId = -1;
        confirmEvent = null;
        closeEvent = null;
        trueCloseEvent = null;
        noMask = false;

        get isMac() {
            return isMac;
        }

        show(obj) {
            this.title = obj.title || this.$t("tip");
            this.content = obj.content;
            this.useDark = obj.useDark;
            this.isPC = obj.isPC;
            this.confirmText = obj.confirmText;
            this.cancelText = obj.cancelText;
            this.useIcon = obj.useIcon;
            this.width = obj.width || 400;
            this.eventId = obj.id;
            this.confirmEvent = obj.confirmEvent;
            this.closeEvent = obj.closeEvent;
            this.trueCloseEvent = obj.trueCloseEvent;
            this.noMask = obj.noMask;
        }

        close() {
            if (this.useAsPlugin) {
                let ts: any = this;
                ts.$removeDom();
            } else {
                if (this.trueCloseEvent) {
                    this.trueCloseEvent();
                } else if (this.closeEvent) {
                    this.closeEvent();
                }
            }
        }
        confirm() {
            if (this.useAsPlugin) {
                let ts: any = this;
                ts.$bus.$emit("edmodal-confirm", this.eventId);
                ts.$removeDom();
            }
            this.confirmEvent && this.confirmEvent();
        }
        cancel() {
            if (this.useAsPlugin) {
                let ts: any = this;
                ts.$removeDom();
            } else {
                this.closeEvent && this.closeEvent();
            }
        }

        created() {}
        mounted() {
            this.$bus.$on("setThemeMode", (e) => {
                this.useDark = e;
            });
        }
    }
</script>
